import React, { useEffect, useState } from 'react';
import {  } from 'antd';
import { IUseEarlyAccessResults } from '@pro/activity/testerClub/useEarlyAccessResults';
import TopInfo from '@pro/activity/testerClub/ResultsContent/ResultsProduct/TopInfo';
import styles from './index.module.less';
import { useTrans } from 'base/utils/i18n'
import ProductImages from '@pro/activity/testerClub/Products/ProductImages'
import cn from 'classnames';
import Image from '@base/lib/ThemeImage';

type IProps = {
    results: IUseEarlyAccessResults
}

const ResultsProduct: React.FC<IProps> = (props) => {

    const { results } = props
    const { resultsData } = results

    const { t } = useTrans();

    return(
        <div className={styles['product-wrap']}>
            <TopInfo resultsData={resultsData}/>

            <div className={styles['close-tips']}>
                {t('web_shop_activity_early_access_applications_closed')}
            </div>

            <div className={cn(styles['product'], 'flex')}>
                <div className={styles['left-box']}>
                    <Image
                        className={'g-sns-icon'}
                        alt={resultsData?.images?.[0].alt || ''}
                        src={resultsData?.images?.[0].url || ''}
                        width={100}
                        fixed
                        background={false}
                    />
                </div>
                <div className={styles['right-box']}>
                    <p className={styles['product-title']}>
                        {resultsData?.title}
                    </p>
                </div>
            </div>


        </div>
    );
};

export default ResultsProduct;